import { useEffect } from "react";
import Intercom from "@intercom/messenger-js-sdk";
import { INTERCOM_APP_ID } from "@/lib/configs";

const useIntercom = (user) => {
  useEffect(() => {
    if (!window.Intercom) {
      const script = document.createElement("script");
      script.src = `https://widget.intercom.io/widget/${INTERCOM_APP_ID}`;
      script.async = true;
      document.body.appendChild(script);
    }

    if (user) {
      Intercom({
        app_id: `${INTERCOM_APP_ID}`,
        user_id: user?.id,
        name: user?.name,
        email: user?.email,
        created_at: user?.createdAt,
      });
    } else {
      Intercom({ app_id: `${INTERCOM_APP_ID}` });
    }
  }, [user]);
};

export default useIntercom;
